module.exports = __webpack_public_path__ + "static/fonts/fa-regular-400.8e9f0ee.eot";